import CoreUtils from '../../common/utils/CoreUtils';

import ConfigurationApi from '../../api-services/ConfigurationApi';

import PropertyPageDataModel from '../../common/controls/PropertyPageDataModel';

import SettingValues from './models/SettingValues';

export default class SettingsDataModel extends PropertyPageDataModel {
  constructor(session, modificationStateUpdated) {
    super(session, modificationStateUpdated);

    this.settingValuesStateListener = this.onSettingValuesStateUpdated.bind(this);

    this.settingValues = new SettingValues();
    this.settingViewGroups = [];

    this.settingValueIndex = {};
    this.settingGuidIndex = {};

    this.loadSettings();
  }

  dispose() {
    this.settingValues?.removeStateListener(this.settingValuesStateListener);
    this.settingValues?.dispose();
    this.settingValues = null;

    super.dispose();
  }

  onPropertyUpdated(propertyName, oldValue, newValue) {
    switch (propertyName) {
      case 'settingValues':
        oldValue?.removeStateListener(this.settingValuesStateListener);
        oldValue?.dispose();

        newValue?.addStateListener(this.settingValuesStateListener);

        this.notifyModificationStateUpdated({
          isModified: newValue?.groupIsModified ?? false,
          hasErrors: newValue?.groupHasErrors ?? false
        });

        break;
      default:
        break;
    }
  }

  onSettingValuesStateUpdated(state) {
    this.notifyModificationStateUpdated(this.translateState(state));
  }

  submitChanges(operationCompleteHandler) {
    this.processSubmitRequest(operationCompleteHandler);
  }

  revertChanges() {
    this.settingValues?.revertGroupItemValues();
  }

  async loadSettings() {
    var settingDtos = await ConfigurationApi.retrieveSettings();
    var settingsIndex = this.createSettingsIndex(settingDtos);

    var settingValues = this.createSettingsDataModel(settingsIndex);
    var settingViewGroups = this.createSettingViewGroups(settingsIndex);

    this.settingValueIndex = this.createSettingValueIndex(settingsIndex);

    this.updateProperties({
      settingValues: settingValues,
      settingViewGroups: settingViewGroups
    });
  }

  createSettingsIndex(settingDtos) {
    var settingsIndex = {};

    settingDtos.forEach(settingDto =>
      settingsIndex[settingDto.identifier] = settingDto
    );

    return settingsIndex;
  }

  createSettingsDataModel(settingsIndex) {
    var settingValueDtos = [];
    var metadataRules = {};

    CoreUtils.getObjectPropertyNames(settingsIndex).forEach(identifier => {
      var settingDto = settingsIndex[identifier];
      settingValueDtos.push(settingDto.value);
      metadataRules[identifier] = settingDto.metadataRule;
    });

    var settingValues = new SettingValues(metadataRules);
    settingValues.initDataObject(settingValueDtos);

    return settingValues;
  }

  createSettingViewGroups(settingsIndex) {
    var settingCategoryIndex = {};

    CoreUtils.iterateProperties(settingsIndex, (identifier, settingDto) => {
      var settings = settingCategoryIndex[settingDto.category];
      if (CoreUtils.isUndefinedOrNull(settings)) {
        settings = [];
        settingCategoryIndex[settingDto.category] = settings;
      }

      settings.push({
        identifier: identifier,
        name: settingDto.name,
        description: settingDto.description,
        units: settingDto.units,
        editWidth: settingDto.editWidth
      });
    });

    return CoreUtils.getObjectPropertyNames(settingCategoryIndex)
      .toSorted()
      .map(category => {
        return {
          category: category,
          settings: settingCategoryIndex[category]
        }
      });
  }

  createSettingValueIndex(settingsIndex) {
    var settingValueIndex = {};

    CoreUtils.iterateProperties(settingsIndex, (identifier, settingDto) => {
      settingValueIndex[identifier] = settingDto.value;
    });

    return settingValueIndex;
  }

  async processSubmitRequest(operationCompleteHandler) {
    if (this.settingValues == null)
      return;

    var settingValueDtos = this.settingValues.getDtoObject(true);

    ConfigurationApi.updateSettingValues(settingValueDtos).then(
        putResult => this.processSubmitResponse(
          putResult, settingValueDtos.length, operationCompleteHandler
        ));
  }

  async processSubmitResponse(putResult, submissionCount, operationCompleteHandler) {
    var successes = 0;
    var failures = 0;

    if (putResult.ok) {
      var settingValueDtos = await putResult.json();
      this.settingValues?.commitUpdatedValues(settingValueDtos);

      successes += settingValueDtos.length;
    }
    else
      failures += submissionCount;

    operationCompleteHandler({
      successes: successes,
      failures: failures
    });
  }

  translateState(state) {
    var translatedState = {};

    if (state.groupIsModified !== undefined)
      translatedState.isModified = state.groupIsModified;

    if (state.groupHasErrors !== undefined)
      translatedState.hasErrors = state.groupHasErrors;

    return translatedState;
  }
}